import { AT_SETTINGS_OPENED_SET, ICookieDialogSettingsOpenSetAction } from './types';

export const settingsOpenSet = (
    isSettingsOpened: boolean
): ICookieDialogSettingsOpenSetAction => ({
    type: AT_SETTINGS_OPENED_SET,
    isSettingsOpened: isSettingsOpened
});
